import { environment } from '@/environments/environment';
import { IConfiguration } from './IConfig';

export const AppConfig: IConfiguration = {
  applicationName: environment.appName,
  applicationVersion: environment.appVersion,
  environment: environment.envType,
  productionModeEnabled: environment.production,
};
